import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { PerformanceProgressTable } from "../Table/PerformanceProgressTable";
import PerformanceTable from "./PerformanceTable";
import GoodProductTable from "./GoodProduct";
import SynergyTable from "./Synergy";
import PerformanceWork from "./PerformanceWork";
import ValueChain from "./ValueChain";
import GoodPeople from "./GoodPeople";

export default function KPIs() {
  const handleLogout = (event) => {
    event.preventDefault();
    sessionStorage.clear("token");
    window.location = "/login";
  };

  return (
    <div>
      <div className="navbar">
        <a href="/home">
          <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
        </a>
        <button className="logout-btn" onClick={handleLogout}>
          Log out
        </button>
      </div>
      <div className="global-market-container">
        <div className="performance-grid">
          <Link className="global-market-menuitem" to="/performance">
            ยอดขายโดยรวม
          </Link>
          <Link className="global-market-menuitem" to="/performance/progress">
            ผลดำเนินงาน
          </Link>
          <Link className="global-market-menuitem" to="/performance/KPIs">
            KPIs
          </Link>
        </div>
        <PerformanceTable />
        <GoodProductTable />
        <SynergyTable />
        <PerformanceWork />
        <ValueChain />
        <GoodPeople />
      </div>
    </div>
  );
}
